import { Dayjs } from "dayjs";

export enum SCHEDULE_MODE {
  DEFAULT = '',
  ENROL = 'enrol',
  TRIAL = 'trial'
}

export enum SCREEN_SIZE {
  SMALL = 'small-screen',
  MEDIUM = 'medium-screen',
  LARGE = 'large-screen',
  EXTRA_LARGE = 'extra-large-screen'
}

export enum DAY_OF_WEEK {
  MONDAY = "Monday",
  TUESDAY = "Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday",
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
  SUNDAY = "Sunday"
};

export enum FEE_TAX_SETTING {
  NO_TAX = "NoTax",
  TAX_INCLUDED = "TaxIncluded",
  TAX_EXCLUDED = "TaxExcluded"
}

export interface IDateOnlyRange {
  startDate: Dayjs;
  endDate: Dayjs;
}

export interface IOptionsItem {
  label?: string;
  value: string;
}

export interface IAddress {
  fullAddress: string;
  street: string;
  suburb: string;
  city: string;
  region: string;
  postalCode: string;
  country: string;
  countryCode: string;
  addressId: string;
  geoPoint?: IGeoPoint | null;
}

export interface IGeoPoint {
  latitude: number;
  longitude: number;
}
